export const companies = [
  {
    id: 'ipay9vip',
    name: 'iPay9vip',
    logo: '/gamelist/companies/ipay9vip.png',
    casinoUrl: 'https://www.ipay9aud.co/en-au/?ref=IPAY9C9C43',
  },
  {
    id: 'ipay9',
    name: 'iPay9',
    logo: '/gamelist/companies/ipay9.png',
    casinoUrl: 'https://i9aud.net/RFPOKINOMICS1',
  },
  {
    id: 'kingbet9',
    name: 'Kingbet9',
    logo: '/gamelist/companies/kingbet9.png',
    casinoUrl: 'https://kingbett9.com/RFPOKINOMICS13',
  },
  {
    id: 'bigpay77',
    name: 'Bigpay77',
    logo: '/gamelist/companies/bigpay77.png',
    casinoUrl: 'https://bigpay77.co/RFBPOKINOMICS',
  },
  {
    id: 'me99',
    name: 'Me99',
    logo: '/gamelist/companies/me99.png',
    casinoUrl: 'https://me99aus.net/RFPOKINOMICSME',
  },
  {
    id: 'rolex9',
    name: 'Rolex9',
    logo: '/gamelist/companies/rolex9.png',
    casinoUrl: 'https://rolex9au.com/RFPOKINOMICSS',
  },
  {
    id: 'gucci9',
    name: 'Gucci9',
    logo: '/gamelist/companies/gucci9.png',
    casinoUrl: 'https://gucci9au.org/RFPOKINOMICSG',
  },
  {
    id: 'mrbean9',
    name: 'MrBean9',
    logo: '/gamelist/companies/mrbean9.png',
    casinoUrl: 'https://mrbean9au.com/RFPOKINOMICSM',
  },
  {
    id: 'mrboom9',
    name: 'MrBoom9',
    logo: '/gamelist/companies/mrboom9.png',
    casinoUrl: 'https://mrboom9.com/RFPPOKINOMICS',
  },
  {
    id: 'spinaroo',
    name: 'Spinaroo',
    logo: '/gamelist/companies/spinaroo.png',
    casinoUrl: 'https://spinarooaus.com/RFPOKINOMICSP',
  },
  {
    id: 'winnie777',
    name: 'Winnie777',
    logo: '/gamelist/companies/winnie777.png',
    casinoUrl: 'https://winnie777.net/RFPOKINOMICSWI',
  },
  {
    id: 'queen13',
    name: 'Queen13',
    logo: '/gamelist/companies/queen13.png',
    casinoUrl: 'https://queen13au.com/RFPOKINOMICSQU',
  },
  {
    id: 'micky9',
    name: 'Micky9',
    logo: '/gamelist/companies/micky9.png',
    casinoUrl: 'https://micky9.net/RFPOKINOMICSMI',
  },
  {
    id: 'bybid9',
    name: 'Bybid9',
    logo: '/gamelist/companies/bybid9.png',
    casinoUrl: 'https://bybid9.net/RFPOKINOMICS',
  },
];
